import { Link } from 'react-router-dom'
import { useFeatureFlags } from '../lib/featureFlags'

export default function MarketingFooter() {
  const { flags } = useFeatureFlags()
  const productLinks = [
    { label:'Features', to:'/features' },
    { label:'Pricing', to:'/pricing' },
    { label:'Love Stories', to:'/stories' },
    ...(flags.about !== false ? [{ label:'About Us', to:'/about' }] : []),
    { label:'Docs', to:'/docs' },
    { label:'Sign Up', to:'/signup' },
    ...(flags.become_vendor !== false ? [{ label:'Become a Vendor', to:'/aisle/become-a-vendor' }, { label:'Vendor Portal', to:'/vendor' }] : []),
  ]
  return (
    <footer style={{ background:'#1A1A1A', paddingTop:'4rem', paddingBottom:'2rem' }}>
      <div style={{ maxWidth:1100, margin:'0 auto', padding:'0 2rem' }}>

        {/* Top: logo + tagline + columns */}
        <div style={{ display:'grid', gridTemplateColumns:'1.4fr 1fr 1fr 1fr', gap:'3rem', marginBottom:'3rem' }}>
          {/* Brand */}
          <div>
            <img src="/okoiya-logo.png" alt="Okoiya" style={{ height:36, objectFit:'contain', filter:'brightness(10)', marginBottom:'1rem', display:'block' }}/>
            <p style={{ fontFamily:'Nunito Sans, sans-serif', fontSize:'0.875rem', color:'rgba(255,255,255,0.55)', lineHeight:1.7, margin:'0 0 0.5rem' }}>
              Your wedding, beautifully organized.
            </p>
            <p style={{ fontFamily:'Nunito Sans, sans-serif', fontSize:'0.875rem', color:'rgba(255,255,255,0.4)', lineHeight:1.7, margin:0 }}>
              Made with love for couples... and the world.
            </p>
          </div>

          {/* Product */}
          <div>
            <p style={{ fontFamily:'Nunito Sans, sans-serif', fontSize:'0.7rem', fontWeight:700, color:'rgba(255,255,255,0.35)', textTransform:'uppercase', letterSpacing:'0.12em', marginBottom:'1rem' }}>Product</p>
            {productLinks.map(l=>(
              <div key={l.label} style={{ marginBottom:'0.625rem' }}>
                <Link to={l.to} style={{ fontFamily:'Nunito Sans, sans-serif', fontSize:'0.875rem', color:'rgba(255,255,255,0.65)', textDecoration:'none', transition:'color 0.2s' }}
                  onMouseEnter={e=>e.currentTarget.style.color='#C4826A'}
                  onMouseLeave={e=>e.currentTarget.style.color='rgba(255,255,255,0.65)'}>
                  {l.label}
                </Link>
              </div>
            ))}
          </div>

          {/* Legal */}
          <div>
            <p style={{ fontFamily:'Nunito Sans, sans-serif', fontSize:'0.7rem', fontWeight:700, color:'rgba(255,255,255,0.35)', textTransform:'uppercase', letterSpacing:'0.12em', marginBottom:'1rem' }}>Legal</p>
            {[{label:'Privacy Policy',to:'/privacy'},{label:'Terms of Service',to:'/terms'},{label:'Cookie Policy',to:'/privacy'}].map(l=>(
              <div key={l.label} style={{ marginBottom:'0.625rem' }}>
                <Link to={l.to} style={{ fontFamily:'Nunito Sans, sans-serif', fontSize:'0.875rem', color:'rgba(255,255,255,0.65)', textDecoration:'none', transition:'color 0.2s' }}
                  onMouseEnter={e=>e.currentTarget.style.color='#C4826A'}
                  onMouseLeave={e=>e.currentTarget.style.color='rgba(255,255,255,0.65)'}>
                  {l.label}
                </Link>
              </div>
            ))}
          </div>

          {/* Connect */}
          <div>
            <p style={{ fontFamily:'Nunito Sans, sans-serif', fontSize:'0.7rem', fontWeight:700, color:'rgba(255,255,255,0.35)', textTransform:'uppercase', letterSpacing:'0.12em', marginBottom:'1rem' }}>Connect</p>
            {[
              {label:'support@okoiya.com', href:'mailto:support@okoiya.com'},
              {label:'Instagram', href:'https://www.instagram.com/theokoiya'},
              {label:'Twitter / X', href:'#'},
              {label:'TikTok', href:'#'},
            ].map(l=>(
              <div key={l.label} style={{ marginBottom:'0.625rem' }}>
                <a href={l.href} target={l.href.startsWith('http')?'_blank':undefined} rel={l.href.startsWith('http')?'noopener noreferrer':undefined}
                  style={{ fontFamily:'Nunito Sans, sans-serif', fontSize:'0.875rem', color:'rgba(255,255,255,0.65)', textDecoration:'none', transition:'color 0.2s' }}
                  onMouseEnter={e=>e.currentTarget.style.color='#C4826A'}
                  onMouseLeave={e=>e.currentTarget.style.color='rgba(255,255,255,0.65)'}>
                  {l.label}
                </a>
              </div>
            ))}
          </div>
        </div>

        {/* Divider */}
        <div style={{ borderTop:'1px solid rgba(255,255,255,0.1)', paddingTop:'1.5rem', display:'flex', alignItems:'center', justifyContent:'space-between', flexWrap:'wrap', gap:'0.5rem' }}>
          <p style={{ fontFamily:'Nunito Sans, sans-serif', fontSize:'0.78rem', color:'rgba(255,255,255,0.35)', margin:0 }}>
            © {new Date().getFullYear()} Okoiya. All rights reserved.
          </p>
        </div>
      </div>

      <style>{`
        @media (max-width:768px) {
          footer > div > div:first-child {
            grid-template-columns: 1fr !important;
            gap: 2rem !important;
          }
          footer > div > div:last-child {
            flex-direction: column !important;
            align-items: center !important;
            text-align: center !important;
          }
        }
      `}</style>
    </footer>
  )
}
